import {createContext} from 'react';

export const FeedListContext = createContext({
    refreshFeeds: () => {}
});
